var BufferFormatter = require('bufferformatter');
var Overlay = require('overlay');
var RenderReasons = require('renderreasons');
var DialogView = require('dialogview');


var BufferPromptHandler = Backbone.View.extend({
    initialize: function (options) {
        this.connection = this.model.connection;
        this.bindMessageHandlers();
        
        this.formatter = new BufferFormatter(this.model);
        this.model.on('remove', this.remove, this);
    },
    bindMessageHandlers: function () {
        for (var type in this.messageHandlers) {
            this.model.bind('message:' + type, this.handleMessage, this);
        }
        this.model.bind('sayError', this.postError, this);
        this.model.bind('postError', this.postError, this);
        this.model.bind('inlineImageConfirm', this.inlineImageConfirm, this);
        this.model.bind('inlineMastodonConfirm', this.inlineMastodonConfirm, this);
        this.model.bind('longMessageConfirm', this.longMessageConfirm, this);
        this.model.bind('deleteMessageConfirm', this.deleteMessageConfirm, this);
        this.model.bind('editMessagePrompt', this.editMessagePrompt, this);
    },
    defaultHead: function () {
        return this.formatter.linkModel(this.connection, {
            name: this.connection.getFullLabel()
        });
    },
    longMessageConfirm: function (onConfirm, onCancel) {
        var confirmHtml = "You’re about to send a very long message. Are you absolutely sure?";
        var overlay = this.htmlConfirm(confirmHtml, onConfirm, {
            okText: 'Yes',
            head: 'Long message warning',
            onCancel: onCancel
        });
        this.triggerAdd(overlay);
    },
    inlineImageConfirm: function (callback) {
        this.model.session.trigger('inlineImageConfirm', _.bind(function () {
            this.model.enableInlineImages();
        }, this));
    },
    inlineMastodonConfirm: function (callback) {
        this.model.session.trigger('inlineMastodonConfirm', _.bind(function () {
            this.model.setInlineMastodonPref(true);
        }, this));
    },
    deleteMessageConfirm: function (message, callback) {
        var overlay;
        if (message.isRedactable()) {
            overlay = this.prompt("Are you sure you want to delete this message? Reason (optional)", _.bind(function (reason) {
                this.model.redactMessage(message.get('msgid'), reason);
                if (callback) {
                    callback();
                }
            }, this));
        } else {
            overlay = this.confirm("Are you sure you want to delete this message?", _.bind(function () {
                this.model.deleteMessage(message.get('msgid'));
                if (callback) {
                    callback();
                }
            }, this));
        }
        overlay.className = 'delete_message_prompt';
        this.triggerAdd(overlay);
    },
    editMessagePrompt: function (message, callback) {
        var overlay = this.prompt("Edit message", _.bind(function (newMsg) {
            this.model.editMessage(message.get('msgid'), newMsg);
            if (callback) {
                callback();
            }
        }, this), message.get('msg'), {
            multiline: true
        });
        overlay.className = 'edit_message_prompt';
        this.triggerAdd(overlay);
    },
    postError: function (response, message) {
        var alertText = this.formatter.escapeText(RenderReasons.renderPostError(response, message));
        var overlay = new Overlay(alertText, {
            className: 'buffer_post_error',
            prompt: true,
            head: this.defaultHead(),
            doneText: 'OK'
        });
        this.triggerAdd(overlay);
    },
    handleMessage: function (message) {
        if (!message.eid || message.eid < 0) {
            var overlay = this.messageHandlers[message.type].call(this, message);
            if (overlay) {
                overlay.message = message;
                this.triggerAdd(overlay);
                return true;
            }
        }
    },
    triggerAdd: function (overlay) {
        this.trigger('addOverlay', overlay);
    },
    alert: function (content, options) {
        return this.htmlAlert(this.formatter.render(content), options);
    },
    htmlAlert: function (content, options) {
        options = options || {};
        return new Overlay(content, {
            prompt: true,
            head: options.head || this.defaultHead(),
            doneText: 'OK'
        });
    },
    confirm: function (content, onConfirm, options) {
        return this.htmlConfirm(this.formatter.render(content), onConfirm, options);
    },
    htmlConfirm: function (content, onConfirm, options) {
        options = options || {};
        var confirmClass = options.confirmClass || 'action';
        var confirmButton = $('<button class="confirm">').addClass(confirmClass).append($('<span>').text(options.okText || 'OK'));
        confirmButton.keypress(function (e) {
            if (e.which == 3) {
                // enter key
                e.preventDefault();
                fullContent.submit();
            }
        });

        var buttons = $('<p class="buttons">');
        buttons.append(confirmButton);
        var extra = options.extraButton;
        var extraButton;
        if (extra) {
            extraButton = $('<button type="button" class="extra">');
            extraButton.addClass(extra.className);
            extraButton.append($('<span>').text(extra.text));
            buttons.append(extraButton);
        }
        var extraButtonHtml = options.extraButtonHtml;
        if (extraButtonHtml) {
            buttons.append(extraButtonHtml);
        }
        if (options.cancel !== false) {
            var cancelButton = $('<button type="button" class="close">').append($('<span>').text('Cancel'));
            buttons.append(cancelButton);
        }

        var contentTag = options.contentTag || 'p';
        var textContainer = $('<' + contentTag + ' class="content">').append(content);
        var fullContent = $('<form action="">');
        if (options.error) {
            fullContent.append($('<p class="userError">').html(options.error).show());
        }
        fullContent.append(textContainer);
        
        if (options.prompt) {
            var multiline = this.connection.hasMultiline() && options.multiline;
            var input = multiline ? $('<textarea class="input prompt">') : $('<input class="input prompt">');
            if (options.promptHint) {
                input.attr('placeholder', options.promptHint);
            }
            if (options.prompt !== true) {
                input.val(options.prompt);
            }
            if (options.onPromptKey) {
                input.on('input', function (e) {
                    options.onPromptKey(e, input, textContainer);
                });
            }
            fullContent.append($('<p class="form">').append(input));
        }
        
        fullContent.append(buttons);

        if (options.extraContent) {
            fullContent.append($('<div class="extraPromptContent">').append(options.extraContent));
        }
        
        var keepFocus = !!DialogView.open;
        if ('keepFocus' in options) {
            keepFocus = options.keepFocus;
        }
        var overlay = new Overlay(fullContent, {
            prompt: true,
            head: options.head || this.defaultHead(),
            keepFocus: true,
            doneText: null,
            onCancel: options.onCancel,
            afterAppend: options.afterAppend || _.bind(function () {
                if (!keepFocus) {
                    if (options.prompt) {
                        input.focus().select();
                    } else {
                        confirmButton.focus();
                    }
                }
            }, this)
        });
        
        var submitted = false;
        
        function doConfirm (e) {
            e.preventDefault();
            if (submitted) {
                return;
            }
            // Disable and mark as already submitted
            var formData = fullContent.serializeForm();
            var formDataArray = fullContent.serializeArray();
            fullContent.find('input, button, textarea').blur().prop('disabled', true);
            submitted = true;
            overlay.hide();
            if (options.prompt) {
                onConfirm(input.val(), formData);
            } else {
                onConfirm(formData, formDataArray);
            }
        }

        if (extra) {
            var extraSubmitted = false;
            extraButton.on('buttonClick', _.bind(function (e) {
                if (extra.form) {
                    if (extraSubmitted) {
                        return;
                    }
                    // Disable and mark as already submitted
                    fullContent.find('input, button, textarea').blur().prop('disabled', true);
                    extraSubmitted = true;
                }
                if (extra.hide) {
                    overlay.hide();
                }
                if (extra.action) {
                    extra.action();
                }
            }, this));
        }

        fullContent.submit(doConfirm);
        return overlay;
    },
    prompt: function (content, onConfirm, prompt, options) {
        return this.htmlPrompt(this.formatter.render(content), onConfirm, prompt, options);
    },
    htmlPrompt: function (content, onConfirm, prompt, options) {
        options = options || {};
        options.prompt = prompt || true;
        return this.htmlConfirm(content, onConfirm, options);
    },
    messageHandlers: {}
});


module.exports = BufferPromptHandler;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/bufferprompthandler.js
// module id = JGoS
// module chunks = 1